import { lazy } from "react";

export const PaymentLazy = lazy(() => import("./payment"));
export const SuccessfulPaymentLazy = lazy(
  () => import("./payment/successfulPayment")
);
export const ProjectsLazy = lazy(() => import("./projects"));
export const EditProjectLazy = lazy(() => import("./projects/editProject"));
export const ProjectPageLazy = lazy(() => import("./projects/projectPage"));
export const FolderPageLazy = lazy(
  () => import("./projects/projectPage/folderPage")
);
export const ProfileLazy = lazy(() => import("./profile"));
export const PageSettingsLazy = lazy(() => import("./pageSettings"));
export const NewFolderLazy = lazy(() => import("./newFolder"));
export const ShareSettingsLazy = lazy(() => import("./shareSettings"));
export const PageCategoryLazy = lazy(() => import("./pageCategory"));
export const ShowCategoryLazy = lazy(
  () => import("./pageCategory/showCategory")
);
export const NewCategoryLazy = lazy(() => import("./pageCategory/NewCategory"));
export const EditCategoryLazy = lazy(
  () => import("./pageCategory/editCategory")
);
export const TemplatesLazy = lazy(() => import("./templates"));
export const CreateTemplateLazy = lazy(
  () => import("./templates/createTemplate")
);
export const UpdateTemplateLazy = lazy(
  () => import("./templates/updateTemplate")
);
export const ShowTemplateLazy = lazy(() => import("./templates/showTemplate"));
export const TemplateCategoryLazy = lazy(() => import("./templateCategory"));
export const NewTemplateCategoryLazy = lazy(
  () => import("./templateCategory/newCategory")
);
export const ShowTemplateCategoryLazy = lazy(
  () => import("./templateCategory/showCategory")
);
export const EditTemplateCategoryLazy = lazy(
  () => import("./templateCategory/editCategory")
);
export const ShadedPagesLazy = lazy(() => import("./shadedPages"));
export const SupportLazy = lazy(() => import("./support"));
export const GetQRCodeLazy = lazy(() => import("./getQRCode"));
export const StatisticsLazy = lazy(() => import("./statistics"));
export const AllPagesLazy = lazy(() => import("./allPages"));
export const AllFoldersLazy = lazy(() => import("./allFolders"));
export const AddNewProjectLazy = lazy(
  () => import("./newProject/addNewProject")
);
export const DomainSetupLazy = lazy(() => import("./newProject/domainSetup"));
export const CompleteStepLazy = lazy(() => import("./newProject/completeStep"));
export const AddDomainLazy = lazy(
  () => import("./projects/editProject/addDomain")
);
export const UserAdministrationLazy = lazy(
  () => import("./userAdministration")
);
export const PageBlockerLazy = lazy(() => import("./pageBlocker"));
export const SubpageTemplatesLazy = lazy(() => import("./subpageTemplates"));
export const CreateFormLazy = lazy(
  () => import("./subpageTemplates/createForm")
);
export const EditFormLazy = lazy(() => import("./subpageTemplates/editForm"));
export const SubmissionsLazy = lazy(() => import("./submissions"));
